import { render, staticRenderFns } from "./HostSettingsPanel.vue?vue&type=template&id=427fb8e0&scoped=true"
import script from "./HostSettingsPanel.vue?vue&type=script&lang=js"
export * from "./HostSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./HostSettingsPanel.vue?vue&type=style&index=0&id=427fb8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427fb8e0",
  null
  
)

export default component.exports